// Sentry and OpenTelemetry stubs for the frontend.
//
// This module provides placeholder functions for error reporting and
// tracing.  In a production system you would import ``@sentry/react``
// and ``@sentry/tracing`` here and initialise them with your DSN and
// environment settings.  For this exercise we simply log messages to
// the console to demonstrate that instrumentation hooks are present.

export function initObservability() {
  if (import.meta.env.PROD) {
    // In production you would call Sentry.init and instrument
    console.info('Observability (Sentry/OTEL) initialised stub');
  }
}

export function captureException(error: unknown) {
  console.error('Captured exception (stub):', error);
}